module.exports = __webpack_public_path__ + "media/a1.c6a99ace.wav";